export enum RANDOM_VALUE {
    logOut = 'NONE_LOGOUT',
    loader = 'NONE_LOADER_SCREEN',
    noneBuiltInApp = 'NON_HANDEL_IN_INTERCEPTOR' 
}